import { Header } from '@/components/header'
import { Footer } from '@/components/footer'
import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'

export default function ThankYou() {
  const [formType, setFormType] = useState('inquiry')

  useEffect(() => {
    window.scrollTo(0, 0)
    
    // Read the query parameter from the URL
    const params = new URLSearchParams(window.location.search)
    const formParam = params.get('form')
    
    if (formParam === 'deck_calculator') {
      setFormType('deck estimate')
    } else if (formParam === 'fence_calculator') {
      setFormType('fence estimate')
    } else {
      setFormType('inquiry')
    }
  }, [])

  const handleNavigation = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault()
    window.history.pushState({}, '', href)
    window.dispatchEvent(new Event('popstate'))
    window.scrollTo(0, 0)
  }

  return (
    <main className="bg-gray-50 min-h-screen flex flex-col">
      <Helmet>
        <title>Thank You | Busy Beaver Construction</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      
      <Header />
      
      <section className="flex-grow flex items-center justify-center py-20 px-4">
        <div className="bg-white p-10 md:p-16 rounded-xl shadow-lg border-t-8 border-beaver-green max-w-2xl w-full text-center">
          <div className="w-20 h-20 bg-green-100 text-beaver-green rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="fas fa-check text-4xl"></i>
          </div>
          
          <h1 className="text-4xl md:text-5xl font-primary text-gray-900 mb-6">
            Thank You!
          </h1>
          
          <p className="text-lg md:text-xl text-gray-600 font-text mb-8 leading-relaxed">
            We have received your {formType}. A member of the Busy Beaver Construction team will review your details and contact you shortly to discuss your project.
          </p>
          
          <div className="space-y-4 md:space-y-0 md:space-x-4 flex flex-col md:flex-row justify-center mt-8">
            <a 
              href="/"
              onClick={(e) => handleNavigation(e, '/')}
              className="inline-block bg-beaver-green text-black font-bold py-3 px-8 rounded hover:brightness-110 transition-all uppercase tracking-wider font-accent text-sm"
            >
              Return Home
            </a>
            <a 
              href="/services"
              onClick={(e) => handleNavigation(e, '/services')}
              className="inline-block bg-gray-900 text-white font-bold py-3 px-8 rounded hover:bg-black transition-all uppercase tracking-wider font-accent text-sm"
            >
              Our Services
            </a>
          </div>
        </div>
      </section>
      
      <Footer />
    </main>
  )
}